import SEO from "@/components/SEO";

const Section = ({ children }) => (
  <section className="py-16 md:py-20">
    <div className="max-w-3xl mx-auto px-6 prose-vt text-navy/80">{children}</div>
  </section>
);
const Header = ({ tag, title, sub }) => (
  <section className="pt-24 pb-10 bg-navy text-cream">
    <div className="max-w-3xl mx-auto px-6">
      <div className="text-xs uppercase tracking-[0.3em] text-accent-brand font-bold mb-4">{tag}</div>
      <h1 className="font-serif text-4xl md:text-5xl text-cream leading-tight">{title}</h1>
      {sub && <p className="text-cream/80 mt-4">{sub}</p>}
    </div>
  </section>
);

export function MentionsLegales() {
  return (<>
    <SEO title="Mentions légales — venteaterme.fr" description="Mentions légales du site venteaterme.fr — éditeur, hébergeur, propriété intellectuelle." />
    <Header tag="Légal" title="Mentions légales" />
    <Section>
      <h2>Éditeur du site</h2>
      <p>
        Le site <strong>venteaterme.fr</strong> est édité par&nbsp;:<br />
        <strong>Sabra Bouilfane</strong> — Entreprise individuelle<br />
        SIREN&nbsp;: <strong>990&nbsp;010&nbsp;217</strong> — RCS Marseille<br />
        Siège&nbsp;: 45 rue de Crimée, 13003 Marseille — France<br />
        Contact&nbsp;: <a href="mailto:contact@venteaterme.fr">contact@venteaterme.fr</a>
      </p>
      <h2>Directrice de la publication</h2>
      <p>Sabra Bouilfane.</p>
      <h2>Hébergement</h2>
      <p>
        Le site est hébergé sur une infrastructure cloud sécurisée localisée dans l'Union européenne.
        Conformément à la <strong>Loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN)</strong>,
        venteaterme.fr agit en qualité d'<strong>hébergeur de contenus</strong> pour les annonces déposées par les
        vendeurs et agences. À ce titre, la plateforme n'a pas d'obligation générale de surveillance des contenus mais met
        en œuvre une modération diligente et un dispositif de signalement.
      </p>
      <h2>Rôle exact de la plateforme</h2>
      <p>
        venteaterme.fr est une <strong>plateforme de diffusion d'annonces immobilières en vente à terme</strong>.
        La plateforme n'est <strong>ni agent immobilier, ni intermédiaire, ni mandataire</strong>, ne perçoit
        <strong> aucune commission</strong> sur les transactions, et n'est pas partie aux contrats de vente.
        Les transactions sont conclues directement entre les parties, <strong>obligatoirement chez notaire</strong>.
      </p>
      <h2>Propriété intellectuelle</h2>
      <p>
        L'ensemble des contenus du site (textes, graphismes, logos, code, photographies) est protégé par le
        droit d'auteur. Toute reproduction, représentation, modification ou adaptation, totale ou partielle,
        est interdite sans autorisation écrite préalable.
      </p>
      <h2>Signalement de contenu</h2>
      <p>
        Pour signaler un contenu manifestement illicite ou une annonce non conforme, écrivez à
        <a href="mailto:contact@venteaterme.fr"> contact@venteaterme.fr</a> en précisant l'URL et le motif.
      </p>
    </Section>
  </>);
}

export function CGU() {
  return (<>
    <SEO title="Conditions générales d'utilisation — venteaterme.fr" description="CGU de venteaterme.fr — plateforme gratuite de diffusion d'annonces en vente à terme immobilière." />
    <Header tag="Légal" title="Conditions générales d'utilisation" sub="Version en vigueur — plateforme gratuite, sans commission" />
    <Section>
      <h2>1. Objet</h2>
      <p>
        Les présentes CGU régissent l'usage de <strong>venteaterme.fr</strong>, plateforme de
        <strong> diffusion d'annonces immobilières en vente à terme</strong>. La plateforme est
        gratuite pour l'ensemble de ses utilisateurs (vendeurs, acheteurs, agences).
      </p>
      <h2>2. Statut LCEN — Hébergeur</h2>
      <p>
        Conformément à la <strong>LCEN (Loi n° 2004-575 du 21 juin 2004)</strong>, venteaterme.fr
        intervient en qualité d'<strong>hébergeur</strong> pour les annonces publiées. La plateforme
        n'exerce <strong>aucune activité d'intermédiation immobilière</strong> au sens de la loi
        Hoguet et n'est pas soumise à l'obligation de carte T.
      </p>
      <h2>3. Rôle exact de la plateforme</h2>
      <p>
        venteaterme.fr met en relation les vendeurs et les acheteurs uniquement par la
        <strong> publication d'annonces</strong>. Les négociations, la rédaction du compromis et
        l'acte définitif se déroulent <strong>directement entre les parties chez notaire</strong>.
        Aucune commission n'est perçue par la plateforme sur les prix ou les mensualités.
      </p>
      <h2>4. Gratuité de la plateforme</h2>
      <p>
        La consultation des annonces, le dépôt d'annonce, l'utilisation du simulateur, de l'estimateur
        et l'ensemble des services de venteaterme.fr sont <strong>100&nbsp;% gratuits</strong>,
        sans frais d'inscription, sans commission, sans honoraires cachés.
      </p>
      <h2>5. Dépôt d'annonces</h2>
      <p>
        Les annonces sont soumises à une modération avant publication. Les déposants garantissent
        l'exactitude des informations et disposent des droits sur les photos transmises. La plateforme
        se réserve le droit de refuser ou retirer toute annonce non conforme.
      </p>
      <h2>6. Diagnostic de performance énergétique (DPE)</h2>
      <p>
        Conformément à l'article L.126-26 du Code de la construction et de l'habitation, la mention du
        <strong> DPE (classe énergie et classe climat)</strong> est <strong>obligatoire</strong> dans
        toute annonce immobilière de vente. Le déposant s'engage à fournir ces informations à jour
        (moins de 10 ans). Pour les logements classés <strong>F ou G</strong>, la mention
        &laquo;&nbsp;logement à consommation énergétique excessive&nbsp;&raquo; doit apparaître.
      </p>
      <h2>7. Confidentialité des coordonnées</h2>
      <p>
        Les coordonnées personnelles des déposants ne sont <strong>jamais affichées publiquement</strong>.
        Les prospects intéressés remplissent un formulaire ; leurs demandes sont transmises au
        déposant via la plateforme.
      </p>
      <h2>8. Responsabilité</h2>
      <p>
        Les informations diffusées le sont à titre indicatif et ne constituent pas un conseil juridique
        ou fiscal. Chaque partie est invitée à consulter un notaire ou un conseiller patrimonial
        avant tout engagement.
      </p>
      <h2>9. Modification des CGU</h2>
      <p>Les présentes CGU peuvent être modifiées à tout moment. La version en vigueur est celle publiée sur le site.</p>
    </Section>
  </>);
}

export function Confidentialite() {
  return (<>
    <SEO title="Politique de confidentialité (RGPD) — venteaterme.fr" description="Politique de confidentialité et traitement des données personnelles conforme au RGPD." />
    <Header tag="Légal" title="Politique de confidentialité" sub="Traitement des données personnelles conformément au RGPD (Règlement UE 2016/679)" />
    <Section>
      <h2>Responsable de traitement</h2>
      <p>
        <strong>Sabra Bouilfane</strong> — SIREN <strong>990&nbsp;010&nbsp;217</strong> — RCS Marseille — 45 rue de Crimée,
        13003 Marseille — <a href="mailto:contact@venteaterme.fr">contact@venteaterme.fr</a>.
      </p>
      <h2>Données collectées</h2>
      <p>
        Nous collectons uniquement les données nécessaires&nbsp;: coordonnées via les formulaires de
        contact, de dépôt d'annonce, de demande d'information sur un bien ou d'alerte. Aucune
        donnée sensible n'est collectée.
      </p>
      <h2>Finalités</h2>
      <ul>
        <li>Traitement des demandes de contact et de mise en relation</li>
        <li>Modération et publication des annonces déposées</li>
        <li>Envoi éventuel d'informations sur des biens correspondant aux critères d'alerte</li>
      </ul>
      <h2>Base légale</h2>
      <p>Consentement de la personne concernée lors de la soumission d'un formulaire.</p>
      <h2>Conservation</h2>
      <p>Les données de contact sont conservées 24 mois, sauf demande de suppression anticipée.</p>
      <h2>Vos droits</h2>
      <p>
        Conformément au règlement européen 2016/679 (RGPD) et à la loi Informatique et Libertés,
        vous disposez d'un droit d'accès, de rectification, d'effacement, de portabilité et
        d'opposition. Pour l'exercer, écrivez à <strong>contact@venteaterme.fr</strong>. Vous
        pouvez introduire une réclamation auprès de la <strong>CNIL</strong> (cnil.fr).
      </p>
      <h2>Cookies</h2>
      <p>Le site n'utilise que des cookies techniques strictement nécessaires à son fonctionnement (aucun cookie publicitaire, aucun tracker tiers).</p>
      <h2>Sécurité</h2>
      <p>
        Les données sont hébergées dans l'Union européenne. Les échanges sont chiffrés en HTTPS.
        L'accès aux données administratives est protégé par authentification.
      </p>
    </Section>
  </>);
}
